var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 113,
    viewBox: "0 0 120 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_334_818)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 112.5C90.9279 112.5 116 87.4279 116 56.5C116 25.5721 90.9279 0.5 60 0.5C29.0721 0.5 4 25.5721 4 56.5C4 87.4279 29.0721 112.5 60 112.5Z",
    fill: "#D7D7D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7672 80.428H56.0991V112.5H64.7672V80.428Z",
    fill: "#F15424"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.173 32.7532H18.8262V81.2947H101.173V32.7532Z",
    fill: "#242D3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7061 36.2205H22.2935V76.9606H97.7061V36.2205Z",
    fill: "#D9D8D7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_334_818",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 36,
    width: 76,
    height: 41
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7061 36.2205H22.2935V76.9606H97.7061V36.2205Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_334_818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.228 76.9606L60.4303 32.7532L91.6385 76.9606H29.228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.55762 76.9606L38.7599 32.7532L69.9681 76.9606H7.55762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0312 76.9606L81.2365 32.7532L112.442 76.9606H50.0312Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9999 32.7532L55.2324 39.6877H64.7674L59.9999 32.7532Z",
    fill: "#242D3C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0969 39.6877L38.3266 32.7532L33.562 39.6877H43.0969Z",
    fill: "#242D3C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6703 32.7532L76.9028 39.6877H86.4378L81.6703 32.7532Z",
    fill: "#242D3C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7061 32.7532H95.8675V25.1252H24.1321V32.7532H22.2935V23.2183H97.7061V32.7532Z",
    fill: "#242D3C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9638 28.4192H33.562V35.3537H43.9638V28.4192Z",
    fill: "#3E4959"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6296 24.9519H37.896V28.4192H39.6296V24.9519Z",
    fill: "#242D3C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6342 28.4192H55.2324V35.3537H65.6342V28.4192Z",
    fill: "#3E4959"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4333 24.9519H58.6997V28.4192H60.4333V24.9519Z",
    fill: "#242D3C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4374 28.4192H76.0356V35.3537H86.4374V28.4192Z",
    fill: "#3E4959"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1033 24.9519H80.3696V28.4192H82.1033V24.9519Z",
    fill: "#242D3C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6296 80.428H37.896V83.8952H39.6296V80.428Z",
    fill: "#242D3C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1033 80.428H80.3696V83.8952H82.1033V80.428Z",
    fill: "#242D3C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7061 83.8953H22.2935V85.6289H97.7061V83.8953Z",
    fill: "#242D3C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6297 57.8909H37.0293V60.4913H39.6297V57.8909Z",
    fill: "#242D3C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1034 57.8909H79.5029V60.4913H82.1034V57.8909Z",
    fill: "#242D3C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M67.967 66.5591H61.2998V51.8232H67.967C69.1956 51.8232 70.352 52.2845 71.2193 53.1146C72.0865 53.9448 72.5684 55.0517 72.5684 56.2278V62.1545C72.5684 63.3305 72.0926 64.4375 71.2193 65.2677C70.352 66.0978 69.1956 66.5591 67.967 66.5591ZM64.3172 63.6765H67.973C68.3946 63.6765 68.7981 63.5208 69.0932 63.2325C69.3944 62.9443 69.563 62.5638 69.563 62.1545V56.2278C69.563 55.8185 69.3944 55.438 69.0993 55.1498C68.7981 54.8615 68.4006 54.7058 67.979 54.7058H64.3232V63.6765H64.3172Z",
    fill: "#F15424"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6997 66.5533H55.6883V56.2221C55.6883 55.8127 55.5257 55.4322 55.2246 55.144C54.9234 54.8557 54.5259 54.7001 54.0983 54.7001H52.0325C51.6049 54.7001 51.2074 54.8615 50.9063 55.1498C50.6112 55.438 50.4425 55.8185 50.4425 56.2278V66.5591H47.4312V56.2278C47.4312 55.0517 47.9069 53.9448 48.7742 53.1146C49.6475 52.2845 50.8039 51.8232 52.0325 51.8232H54.0983C55.327 51.8232 56.4833 52.2845 57.3506 53.1146C58.2179 53.9448 58.6997 55.0517 58.6997 56.2278V66.5591V66.5533Z",
    fill: "#F15424"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6997 57.8909H47.4312V60.4913H58.6997V57.8909Z",
    fill: "#F15424"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_334_818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 112,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerCard);
export default __webpack_public_path__ + "static/media/CustomerCard.9bde0ef735237989def0034fe582acec.svg";
export { ForwardRef as ReactComponent };